"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bitcoinPickingStrategy = exports.BitcoinLikeSigHashType = exports.BitcoinLikeFeePolicy = exports.initialBitcoinResourcesValue = void 0;
exports.initialBitcoinResourcesValue = {
    utxos: [],
};
exports.BitcoinLikeFeePolicy = Object.freeze({
    PER_BYTE: "PER_BYTE",
    PER_KBYTE: "PER_KBYTE",
});
exports.BitcoinLikeSigHashType = Object.freeze({
    SIGHASH_ALL: 0x01,
    SIGHASH_NONE: 0x02,
    SIGHASH_SINGLE: 0x03,
    SIGHASH_FORKID: 0x40,
    SIGHASH_ANYONECANPAY: 0x80,
});
exports.bitcoinPickingStrategy = {
    DEEP_OUTPUTS_FIRST: 0,
    OPTIMIZE_SIZE: 1,
    MERGE_OUTPUTS: 2,
};
//# sourceMappingURL=types.js.map